var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.69024 10.5054C3.93524 10.7504 4.33024 10.7504 4.57524 10.5054L8.73024 6.35039C8.92524 6.15539 8.92524 5.84039 8.73024 5.64539L4.57524 1.49039C4.33024 1.24539 3.93524 1.24539 3.69024 1.49039C3.44524 1.73539 3.44524 2.13039 3.69024 2.37539L7.31024 6.00039L3.68524 9.62539C3.44524 9.86539 3.44524 10.2654 3.69024 10.5054Z",
    fill: "#00FFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.10f14da096c7eeaae8ffd3f720ab6a70.svg";
export { ForwardRef as ReactComponent };